import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.poolI18ns[vm.defaultLanguage].name">
                <label class="label">{{ 'questionPool.Question pool name' | translate }} *</label>
                <div class="items">
                    <input ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" ng-model="vm.form.model.poolI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.status">
                <span class="label">{{ 'questionPool.Status' | translate }}</span>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label ng-repeat="item in vm.FORMS_POOL_ENUM.KEYS">
                                <input
                                    ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()"
                                    ng-model="vm.form.model.status"
                                    value="{{ vm.FORMS_POOL_ENUM.KEYS[item] }}"
                                    type="radio"
                                > {{ vm.FORMS_POOL_ENUM.LABELS[item] }}
                            </label>
                        </li>
                    </ul>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    </form>
    `
})
export default class {
    constructor (FORMS_POOL_ENUM, TokenService, QuestionService) {
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.QuestionService = QuestionService;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    $onInit () {
        if (!this.form.model.status) {
            this.form.model.status = this.FORMS_POOL_ENUM.KEYS.ACTIVE;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/pool/generaldata/index.js